$(function(){
    let dropdownTrigger = $('.dropdown-trigger'),
        dropdowns = $('.dropdown');

    dropdownTrigger.on('click', function(){
       let thisTrigger = $(this);

        if (thisTrigger.attr('aria-expanded') === 'false') {
           thisTrigger.openDropdown();
       } else {
           thisTrigger.closeDropdown();
       }
    });

    function closeDropdowns() {
        dropdowns.each(function(){
            let thisDropdown = $(this),
                thisTrigger = thisDropdown.find('.dropdown-trigger');

            if (!thisDropdown.hasClass('relative')) {
                thisTrigger.attr('aria-expanded', 'false');
                thisDropdown.removeClass('open');
                thisDropdown.find('.dropdown-body').slideUp(200);
            }
        })
    }

    $.fn.openDropdown = function() {
        let thisTrigger = $(this),
            thisDropdown = thisTrigger.next();

        thisTrigger.attr('aria-expanded', 'true');
        thisTrigger.closest('.dropdown').addClass('open');
        thisDropdown.slideDown(200);
    }

    $.fn.closeDropdown = function() {
        let thisTrigger = $(this),
            thisDropdown = thisTrigger.next();

        thisTrigger.attr('aria-expanded', 'false');
        thisTrigger.closest('.dropdown').removeClass('open');
        thisDropdown.slideUp(200);
    }
})